import Truthsorting from "./Truthsorting";

export default Truthsorting;